import React from 'react';
import ReactDOM from 'react-dom/client';

import CustomThemeProvider from './styles/ThemeProvider'; // Import the custom theme provider

import App from './App';
import reportWebVitals from './reportWebVitals';
//import 'bootstrap/dist/cssimport './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './utils/i18n'; // Translation


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
//<React.StrictMode>
    //<Provider store={store}>
    <CustomThemeProvider>
      <App />
    </CustomThemeProvider>
    //</Provider>
//</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
